// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1v5ui","image":"Header_image__2weUF","name":"Header_name__3zIej","info":"Header_info__3GenG","infoRow":"Header_infoRow__3oWlD"};